import { Categoria } from './categoria';

export class Grupo {
  id: number;
  nombre: String;
  categoria: Categoria;
  ent_stock: number;
  ped_stock: number;

  constructor() {
    this.categoria = new Categoria();
  }
}